export default {
  metadata: {
    version: '2.0.0',
    id: 'avatar-2.0.0',
    name: 'JDSAvatarV2'
  },
  hierarchy: {
    container: [
      'jds_avatar_v2_default',
      'jds_avatar_v2_status',
      'jds_avatar_v2_notification',
      'jds_avatar_v2_information',
      'jds_avatar_v2_complete_ring',
      'jds_avatar_v2_segmented_ring',
      'jds_avatar_v2_progress_ring'
    ]
  },
  base: {
    container: {
      hidden: false,
      behavior: {
        focus: {
          'background-color': '{primary60}',
          'border-radius': '{pill}',
          'padding-left': '{xxs}',
          'padding-right': '{xxs}',
          'padding-top': '{xxs}',
          'padding-bottom': '{xxs}'
        }
      }
    },
    jds_avatar_v2_default: {
      hidden: false,
      size: 'medium'
    },
    jds_avatar_v2_status: {
      hidden: true,
      size: 'medium'
    },
    jds_avatar_v2_notification: {
      hidden: true,
      size: 'medium'
    },
    jds_avatar_v2_information: {
      hidden: true,
      size: 'medium'
    },
    jds_avatar_v2_complete_ring: {
      hidden: true,
      size: 'medium'
    },
    jds_avatar_v2_segmented_ring: {
      hidden: true,
      size: 'medium'
    },
    jds_avatar_v2_progress_ring: {
      hidden: true,
      size: 'medium'
    }
  },
  variant: {
    kind: {
      status: {
        jds_avatar_v2_default: {
          hidden: true
        },
        jds_avatar_v2_status: {
          hidden: false
        }
      },
      notification: {
        jds_avatar_v2_default: {
          hidden: true
        },
        jds_avatar_v2_notification: {
          hidden: false
        }
      },
      information: {
        jds_avatar_v2_default: {
          hidden: true
        },
        jds_avatar_v2_information: {
          hidden: false
        }
      },
      'complete-ring': {
        jds_avatar_v2_default: {
          hidden: true
        },
        jds_avatar_v2_complete_ring: {
          hidden: false
        }
      },
      'segmented-ring': {
        jds_avatar_v2_default: {
          hidden: true
        },
        jds_avatar_v2_segmented_ring: {
          hidden: false
        }
      },
      'progress-ring': {
        jds_avatar_v2_default: {
          hidden: true
        },
        jds_avatar_v2_progress_ring: {
          hidden: false
        }
      }
    },
    size: {
      'xtra-small': {
        jds_avatar_v2_default: {
          size: 'xtra-small'
        },
        jds_avatar_v2_status: {
          size: 'xtra-small'
        },
        jds_avatar_v2_notification: {
          size: 'xtra-small'
        },
        jds_avatar_v2_information: {
          size: 'xtra-small'
        },
        jds_avatar_v2_complete_ring: {
          size: 'xtra-small'
        },
        jds_avatar_v2_segmented_ring: {
          size: 'xtra-small'
        },
        jds_avatar_v2_progress_ring: {
          size: 'xtra-small'
        }
      },
      small: {
        jds_avatar_v2_default: {
          size: 'small'
        },
        jds_avatar_v2_status: {
          size: 'small'
        },
        jds_avatar_v2_notification: {
          size: 'small'
        },
        jds_avatar_v2_information: {
          size: 'small'
        },
        jds_avatar_v2_complete_ring: {
          size: 'small'
        },
        jds_avatar_v2_segmented_ring: {
          size: 'small'
        },
        jds_avatar_v2_progress_ring: {
          size: 'small'
        }
      },
      large: {
        jds_avatar_v2_default: {
          size: 'large'
        },
        jds_avatar_v2_status: {
          size: 'large'
        },
        jds_avatar_v2_notification: {
          size: 'large'
        },
        jds_avatar_v2_information: {
          size: 'large'
        },
        jds_avatar_v2_complete_ring: {
          size: 'large'
        },
        jds_avatar_v2_segmented_ring: {
          size: 'large'
        },
        jds_avatar_v2_progress_ring: {
          size: 'large'
        }
      },
      'xtra-large': {
        jds_avatar_v2_default: {
          size: 'xtra-large'
        },
        jds_avatar_v2_status: {
          size: 'xtra-large'
        },
        jds_avatar_v2_notification: {
          size: 'xtra-large'
        },
        jds_avatar_v2_information: {
          size: 'xtra-large'
        },
        jds_avatar_v2_complete_ring: {
          size: 'xtra-large'
        },
        jds_avatar_v2_segmented_ring: {
          size: 'xtra-large'
        },
        jds_avatar_v2_progress_ring: {
          size: 'xtra-large'
        }
      },
      'xtra-xtra-large': {
        jds_avatar_v2_default: {
          size: 'xtra-xtra-large'
        },
        jds_avatar_v2_status: {
          size: 'xtra-xtra-large'
        },
        jds_avatar_v2_notification: {
          size: 'xtra-xtra-large'
        },
        jds_avatar_v2_information: {
          size: 'xtra-xtra-large'
        },
        jds_avatar_v2_complete_ring: {
          size: 'xtra-xtra-large'
        },
        jds_avatar_v2_segmented_ring: {
          size: 'xtra-xtra-large'
        },
        jds_avatar_v2_progress_ring: {
          size: 'xtra-xtra-large'
        }
      }
    },
    disabled: {
      true: {
        container: {
          disabled: true
        }
      }
    }
  },
  combination: [{}],
  combination_config: [[]],
  api: {
    config: {
      kind: {
        values: [
          'default',
          'status',
          'notification',
          'information',
          'complete-ring',
          'segmented-ring',
          'progress-ring'
        ]
      },
      size: {
        values: [
          'medium',
          'xtra-small',
          'small',
          'large',
          'xtra-large',
          'xtra-xtra-large'
        ]
      },
      disabled: {
        values: [false, true]
      }
    },
    data: {
      jds_avatar_v2_default: {
        image: {
          type: 'image',
          name: 'image'
        },
        initials: {
          type: 'string',
          name: 'initials'
        },
        kind: {
          type: 'JDSAvatarV2Default.kind',
          name: 'avatarKind'
        },
        disabled: {
          type: 'boolean',
          name: 'disabled'
        }
      },
      jds_avatar_v2_status: {
        label: {
          type: 'string',
          name: 'badgeLabel'
        },
        avatarImage: {
          type: 'image',
          name: 'image'
        },
        avatarInitials: {
          type: 'string',
          name: 'initials'
        },
        avatarKind: {
          type: 'JDSAvatarV2Default.kind',
          name: 'avatarKind'
        },
        badgeBorder: {
          type: 'boolean',
          name: 'badgeBorder'
        },
        badgeStatus: {
          type: 'JDSBadgeV2Status.status',
          name: 'statusBadgeStatus'
        },
        kind: {
          type: 'JDSAvatarV2Status.kind',
          name: 'statusBadgeKind'
        },
        placement: {
          type: 'JDSAvatarV2Status.placement',
          name: 'statusBadgePlacement'
        },
        disabled: {
          type: 'boolean',
          name: 'disabled'
        }
      },
      jds_avatar_v2_notification: {
        label: {
          type: 'string',
          name: 'badgeLabel'
        },
        avatarImage: {
          type: 'image',
          name: 'image'
        },
        avatarInitials: {
          type: 'string',
          name: 'initials'
        },
        avatarKind: {
          type: 'JDSAvatarV2Default.kind',
          name: 'avatarKind'
        },
        kind: {
          type: 'JDSAvatarV2Notification.kind',
          name: 'notificationBadgeKind'
        },
        disabled: {
          type: 'boolean',
          name: 'disabled'
        }
      },
      jds_avatar_v2_information: {
        label: {
          type: 'string',
          name: 'badgeLabel'
        },
        avatarImage: {
          type: 'image',
          name: 'image'
        },
        avatarInitials: {
          type: 'string',
          name: 'initials'
        },
        avatarKind: {
          type: 'JDSAvatarV2Default.kind',
          name: 'avatarKind'
        },
        badgeBorder: {
          type: 'boolean',
          name: 'badgeBorder'
        },
        badgeIcon: {
          type: 'icon',
          name: 'informationBadgeIcon'
        },
        badgeColor: {
          type: 'JDSBadgeV2Information.color',
          name: 'informationBadgeColor'
        },
        badgeAppearance: {
          type: 'JDSBadgeV2Information.appearance',
          name: 'informationBadgeAppearance'
        },
        kind: {
          type: 'JDSAvatarV2Information.kind',
          name: 'informationBadgeKind'
        },
        placement: {
          type: 'JDSAvatarV2Information.placement',
          name: 'informationBadgePlacement'
        },
        disabled: {
          type: 'boolean',
          name: 'disabled'
        }
      },
      jds_avatar_v2_complete_ring: {
        avatarImage: {
          type: 'image',
          name: 'image'
        },
        avatarInitials: {
          type: 'string',
          name: 'initials'
        },
        avatarKind: {
          type: 'JDSAvatarV2Default.kind',
          name: 'avatarKind'
        },
        disabled: {
          type: 'boolean',
          name: 'disabled'
        }
      },
      jds_avatar_v2_segmented_ring: {
        avatarImage: {
          type: 'image',
          name: 'image'
        },
        avatarInitials: {
          type: 'string',
          name: 'initials'
        },
        avatarKind: {
          type: 'JDSAvatarV2Default.kind',
          name: 'avatarKind'
        },
        disabled: {
          type: 'boolean',
          name: 'disabled'
        },
        count: {
          type: 'number',
          name: 'segmentCount',
          doc_description: 'It can be used to control count of segments.'
        }
      },
      jds_avatar_v2_progress_ring: {
        avatarImage: {
          type: 'image',
          name: 'image'
        },
        avatarInitials: {
          type: 'string',
          name: 'initials'
        },
        avatarKind: {
          type: 'JDSAvatarV2Default.kind',
          name: 'avatarKind'
        },
        disabled: {
          type: 'boolean',
          name: 'disabled'
        },
        progress: {
          type: 'number',
          name: 'progress'
        }
      }
    },
    events: {
      container: {
        onClick: 'onClick'
      }
    },
    a11y: {
      jds_avatar_v2_default: {
        properties: {
          ariaLabel: 'ariaLabel',
          ariaDescribedby: {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          }
        }
      },
      jds_avatar_v2_status: {
        properties: {
          ariaLabel: 'ariaLabel',
          ariaDescribedby: {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          }
        }
      },
      jds_avatar_v2_notification: {
        properties: {
          ariaLabel: 'ariaLabel',
          ariaDescribedby: {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          }
        }
      },
      jds_avatar_v2_information: {
        properties: {
          ariaLabel: 'ariaLabel',
          ariaDescribedby: {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          }
        }
      },
      jds_avatar_v2_complete_ring: {
        properties: {
          ariaLabel: 'ariaLabel',
          ariaDescribedby: {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          }
        }
      },
      jds_avatar_v2_segmented_ring: {
        properties: {
          ariaLabel: 'ariaLabel',
          ariaDescribedby: {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          }
        }
      },
      jds_avatar_v2_progress_ring: {
        properties: {
          ariaLabel: 'ariaLabel',
          ariaDescribedby: {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          }
        }
      }
    }
  }
};
